import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { LoaderService } from './loader.service';
import { MessageService } from './message.service';

@Injectable()
export class DataExportService {


  constructor(public http: HttpClient, public loaderService: LoaderService, public messageService: MessageService) { }

    myData: any;
    myTitle: string;
    // Observable string sources
    private emitChangeSource = new Subject<any>();
    // Observable string streams
    changeEmitted$ = this.emitChangeSource.asObservable();
    // Service message commands
    emitChange(change: any, title:string) {
        this.emitChangeSource.next(title);
        this.myData = change;
        this.myTitle = title;
        //console.log(title);
    }




  public downLoad(): void {

    let name = this.myTitle
    let data = this.myData
    let current_date: Date = new Date();
    let date_String: string = current_date.toISOString();
    date_String = date_String.replace(/T/g, "_")
    date_String = date_String.replace(/:/g, "")
    date_String = date_String.substring(0, date_String.indexOf('.'))
    name = name.replace(/ /g, "_")
    name = name + '_' + date_String

   
    this.loaderService.emitChange(true);
    //this.dataexportService.emitChange(null, "Loading");


    this.messageService.emitChange({ "Message": "Keep an eye on your downloads folder - Your data will download as soon as it\'s ready.", "Css": "success" });

    let myPost = {
      "title": name,
      "data": JSON.stringify(data)
    }
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    this.http.post("/Download/DownloadExcel", JSON.stringify(myPost), { headers: headers, observe: 'response', responseType: 'blob' }).subscribe(
        (res: any) => {
          this.loaderService.emitChange(false);
          if (res.Result == "error") {
            this.messageService.emitChange({ "Css": "error", "Message": res.Message }); 
          } else {
            this.messageService.emitChange({ "Css": "success", "Message": "Data retrieved successfully - report downloading" });

            let fileName = res.headers.get('Content-Disposition')?.split(';')?.[1]?.split('=')?.[1]//.slice(1, -1)
            let contentType = res.headers.get('Content-Type')
            let blob = new Blob([res.body], { type: contentType });
            let a = document.createElement('a');
            a.href = window.URL.createObjectURL(blob); // 'data:text/csv;charset=utf-8,' + encodeURI(csvContent);
            a.target = '_blank';
            a.download = fileName;
            a.click();

            //return this.http.post('/Statement/DownloadExcelDocument', JSON.stringify(myPost), { headers: headers, observe: 'response', responseType: 'blob' })
            //  .subscribe(response => {
            //    this.loaderService.emitChange({ 'loader': false, 'title': 'Skippings' });
            //    let myResponse: any = response;

            //    let fileName = response.headers.get('Content-Disposition')?.split(';')?.[1]?.split('=')?.[1]?.slice(1, -1)
            //    let contentType = response.headers.get('Content-Type')
            //    let blob = new Blob([response.body], { type: contentType });
            //    let a = document.createElement('a');
            //    a.href = window.URL.createObjectURL(blob); // 'data:text/csv;charset=utf-8,' + encodeURI(csvContent);
            //    a.target = '_blank';
            //    a.download = fileName;
            //    a.click();

            //    //if (myResponse.error !== "success") {
            //    //  this.messageService.emitChange({ "Message": myResponse.message, "Css": "error" });
            //    //}
            //    //else {


            //    //}
            //  }, error => {
            //    this.messageService.emitChange({ "Message": error, "Css": "error" });
            //  }


          }
        },
        err => {
          this.messageService.emitChange({ "Css": "error", "Message": err.status });

        }
      );


  }


  public downLoadElastic(data: any = null, name: string = null): void {

    
    let current_date: Date = new Date();
    let date_String: string = current_date.toISOString();
    date_String = date_String.replace(/T/g, "_")
    date_String = date_String.replace(/:/g, "")
    date_String = date_String.substring(0, date_String.indexOf('.'))
    name = name.replace(/ /g, "_")
    name = name + '_' + date_String


    this.loaderService.emitChange(true);
    //this.dataexportService.emitChange(null, "Loading");

    //this.messageService.emitChange({ "Message": "Keep an eye on your downloads folder - Your data will download as soon as it\'s ready.", "Css": "success" });

    let myPost = {
      "title": name,
      "data": JSON.stringify(data)
    }
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    this.http.post("/Download/DownloadExcel", JSON.stringify(myPost), { headers: headers, observe: 'response', responseType: 'blob' }).subscribe(
      (res: any) => {
        this.loaderService.emitChange(false);
        if (res.Result == "error") {
          this.messageService.emitChange({ "Css": "error", "Message": res.Message });
        } else {
          this.messageService.emitChange({ "Css": "success", "Message": "Data retrieved successfully - report downloading" });

          let fileName = res.headers.get('Content-Disposition')?.split(';')?.[1]?.split('=')?.[1]//.slice(1, -1)
          let contentType = res.headers.get('Content-Type')
          let blob = new Blob([res.body], { type: contentType });
          let a = document.createElement('a');
          a.href = window.URL.createObjectURL(blob); // 'data:text/csv;charset=utf-8,' + encodeURI(csvContent);
          a.target = '_blank';
          a.download = fileName;
          a.click();


        }
      },
      err => {
        this.messageService.emitChange({ "Css": "error", "Message": err.status });

      }
    );


  }


  //public downLoadCsv(columns: any = null): void {



  //  let name = this.myTitle
  //  let data = this.myData

  //  name = name.replace(/ /g, "_")

  //  let current_date: Date = new Date();
  //  // Use the toString() method
  //  let date_String: string = current_date.toISOString();

  //  date_String = date_String.replace(/T/g, "_")

  //  date_String = date_String.substring(0, date_String.indexOf('.'))

  //  if (!!columns) {
  //    data.forEach((itm: any) => {
  //      columns.forEach((whichCol: any) => {
  //        console.log(whichCol)
  //        delete itm[whichCol]
  //      })
  //    });
  //  }

  //  console.log('donloadCSV' + data)

  //  let csvContent = this.saveDataInCSV(data);

  //  var hiddenElement = document.createElement('a');
  //  hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csvContent);
  //  hiddenElement.target = '_blank';
  //  hiddenElement.download = 'SpecSavers_' + name + '_' + date_String + '.csv';
  //  hiddenElement.click();
  //}

  //public saveDataInCSV(data: Array<any>): string {
  //  if (data.length == 0) {
  //    return '';
  //  }

  //  let propertyNames = Object.keys(data[0]);
  //  let rowWithPropertyNames = propertyNames.join(',') + '\n';

  //  let csvContent = rowWithPropertyNames;

  //  let rows: string[] = [];

  //  data.forEach((item) => {
  //    let values: string[] = [];

  //    propertyNames.forEach((key) => {
  //      let val: any = item[key];

  //      if (val !== undefined && val !== null) {
  //        val = new String(val);
  //      } else {
  //        val = '';
  //      }
  //      values.push(val.replace(',', ' ').replace(/\n/g, ''));//
  //    });
  //    rows.push(values.join(','));
  //  });
  //  csvContent += rows.join('\n');

  //  return csvContent;
  //}

}
